// extracted by mini-css-extract-plugin
export default {"viewerContainer":"ImpactReportsViewer_viewerContainer__YTeDB"};